import { TrashIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import {
  ReportSectionFieldsType,
  ReportSectionsType,
  useDeleteReportSectionFieldMutation,
} from "@api/graphql/types-and-hooks";
import { ConfirmationDialog } from "@components/ConfirmationDialog/ConfirmationDialog";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface ItemProps {
  onOpen: () => void;
}

export const ReportFieldDropdownMenuRemoveItem: React.FC<ItemProps> = ({ onOpen }) => {
  return (
    <DropdownMenuItem variant="destructive" onClick={onOpen}>
      <TrashIcon />
      Remove Field
    </DropdownMenuItem>
  );
};

interface DialogProps {
  section: ReportSectionsType;
  field: ReportSectionFieldsType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ReportFieldDropdownMenuRemoveDialog: React.FC<DialogProps> = ({ section, field, open, onOpenChange }) => {
  const { reportQuery } = useReport();
  const { mutate: deleteFieldMutate, isPending } = useDeleteReportSectionFieldMutation({
    onSuccess: async (data) => {
      if (data.deleteReportSectionField?.status) {
        await reportQuery.refetch();
      } else if (data.deleteReportSectionField?.status === false) {
        notifyError(data.deleteReportSectionField?.message ?? "Error deleting field");
      }
    },
    onError: (error) => {
      console.error("Error while deleting field:", error);
      notifyError("Error Deleting Field");
    },
    onSettled: () => {
      onOpenChange(false);
    },
  });

  return (
    <ConfirmationDialog
      open={open}
      title="Delete this field?"
      content="This will permanently delete the field. Are you sure you want to continue?"
      submitButtonText="Yes, Delete"
      submitButtonLoading={isPending}
      cancelButtonText="No, Cancel"
      submitButtonAction="destructive"
      onSubmitClick={() => deleteFieldMutate({ sectionId: section.id, fieldId: field.id })}
      onCancelClick={() => onOpenChange(false)}
    />
  );
};
